export class GetMine {
  static readonly type = '[PushMessage] GetMine';
  constructor() {}
}
